import React, { Component } from 'react'

import Footer from '../components/common/Footer'
import { pushGTMUserInfo } from '../util/gtmUtils'

export class FooterLayout extends Component {
  componentDidMount() {
    pushGTMUserInfo()
  }
  render() {
    return (
      <div className="main">
        <article className="content" id="content">
          {this.props.children}
        </article>
        <Footer />
      </div>
    )
  }
}

export default FooterLayout
